import { Autoplay } from "swiper/modules";
import Swiper from "swiper";
import { currencySwitcher } from "../utils/currency-switcher";

class AnnouncementBarElement extends HTMLElement {
  constructor() {
    super();

    const announcementBarElement = this;
    const direction = announcementBarElement.getAttribute("data-orientation");
    const autoplay = announcementBarElement.getAttribute("data-autoplay");
    const autoplaySpeed = announcementBarElement.getAttribute(
      "data-autoplay-speed"
    );

    // Currency selector script

    const textInput = announcementBarElement.querySelector(
      ".currency-search-input"
    );

    textInput?.addEventListener("focus", () => {
      currencyForm.classList.add("currency-form--js-active");
    });

    textInput?.addEventListener("input", (e) => {
      currencySwitcher(e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1)
      );
    });

    const currencySwitcherFooterElement = document.querySelector(
      ".currency-switcher-footer-desktop"
    );

    currencySwitcherFooterElement?.addEventListener("click", () => {
      // Trigger for footer opening currency form online on desktop size
      if (window.innerWidth > 768) {
        currencyForm.classList.add("currency-form--js-active");
      }
    });

    const currencySlector =
      announcementBarElement.querySelector(".current-currency");
    const currencyForm = announcementBarElement.querySelector(".currency-form");
    const closeCurrencyForm =
      announcementBarElement.querySelector(".close-button");
    const currencySelctor = announcementBarElement.querySelector(".currency");

    // currencySelctor.addEventListener("change", () => {});

    closeCurrencyForm?.addEventListener("click", () => {
      currencyForm.classList.remove("currency-form--js-active");
    });

    currencySlector?.addEventListener("click", () => {
      currencyForm.classList.add("currency-form--js-active");
    });

    // End currency selector script

    if (announcementBarElement) {
      const swiperConfig = {
        slidesPerView: 1,
        spaceBetween: 16,
      };

      if (direction) {
        swiperConfig.direction = direction;
      }

      if (autoplay && autoplay === "true") {
        swiperConfig.modules = swiperConfig.modules
          ? [...swiperConfig.modules, Autoplay]
          : [Autoplay];
        swiperConfig.loop = true;
      }

      if (autoplaySpeed && autoplaySpeed > 0) {
        swiperConfig.autoplay = {
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
          delay: autoplaySpeed,
        };
      }

      new Swiper(announcementBarElement, swiperConfig);

      window.addEventListener(
        "shopify:section:load",
        () => new Swiper(announcementBarElement, swiperConfig)
      );
    }
  }
}

// Check if element is defined, if not define it..
// eslint-disable-next-line no-undefined
if (customElements.get("announcement-bar") === undefined) {
  customElements.define("announcement-bar", AnnouncementBarElement);
}
